module.exports = __WEBPACK_EXTERNAL_MODULE_23__;


//////////////////
// WEBPACK FOOTER
// external {"commonjs":"jquery","commonjs2":"jquery","amd":"jquery","root":"$"}
// module id = 23
// module chunks = 0